<div class="form_heading">
  <div class="heading-submenu">
    Personal Information</div>
</div>
<form class="example-form edit-profile-form" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <!-- Gender and Seeking Fields -->
  <div class="form-row">

    <mat-form-field appearance="outline" class="form-field">
      <label for="gender">I am:</label>
      <mat-select id="gender" formControlName="gender" [(ngModel)]="my_gender">
        <mat-option value="" disabled="true">Not Selected</mat-option>
        <mat-option *ngFor="let gender of dropDownData?.genders" [value]="gender._id">{{ gender.name }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('gender')?.hasError('required')">
        Please select your gender.
      </mat-error>
    </mat-form-field>


    <mat-form-field appearance="outline" class="form-field">
      <label for="seeking">Seeking a:</label>
      <mat-select id="seeking" formControlName="seeking">
        <mat-option value="" disabled="true">Not Selected</mat-option>
        <mat-option *ngFor="let gender of dropDownData?.genders" [value]="gender._id">{{ gender.name }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('seeking')?.hasError('required')">
        Please select what you're seeking.
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Date of Birth Fields -->
  <div class="form-row dob">

    <mat-form-field appearance="outline" class="form-field">
      <label for="month">Age:</label>
      <mat-select id="month" formControlName="month">
        <mat-option value="" disabled="true">Not Selected</mat-option>
        <mat-option *ngFor="let month of months" [value]="month.value">{{ month.label }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('month')?.hasError('required')">
        Please select a month.
      </mat-error>
    </mat-form-field>


    <mat-form-field appearance="outline" class="form-field">

      <mat-select id="day" formControlName="day">
        <mat-option value="" disabled="true">Not Selected</mat-option>
        <mat-option *ngFor="let days of daysSelect" [value]="days">{{ days }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('day')?.hasError('required')">
        Please enter a valid day.
      </mat-error>
    </mat-form-field>


    <mat-form-field appearance="outline" class="form-field">

      <mat-select id="year" formControlName="year">
        <mat-option value="" disabled="true">Not Selected</mat-option>
        <mat-option *ngFor="let yearse of years" [value]="yearse">{{ yearse }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('year')?.hasError('required')">
        Please enter a valid year.
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Location Fields -->
  <div class="form-row">

    <mat-form-field appearance="outline" class="form-field">
      <label for="country">Country:</label>
      <mat-select id="country" formControlName="country" (selectionChange)="onCountryChange($event)">
        <mat-option value="" disabled="true">Not Selected</mat-option>
        <mat-option *ngFor="let country of countrys" [value]="country._id">
          {{ country.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('country')?.hasError('required')">
        Please select a country.
      </mat-error>
    </mat-form-field>


    <mat-form-field appearance="outline" class="form-field">
      <label for="state">State:</label>
      <mat-select id="state" formControlName="state" (selectionChange)="onStateChange($event)">
        <mat-option value="" disabled="true">Select</mat-option>
        <mat-option *ngFor="let state of state" [value]="state._id">
          {{ state.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('state')?.hasError('required')">
        Please select a state.
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <label for="city">City:</label>
      <mat-select id="city" formControlName="city">
        <mat-option value="" disabled="true">Select</mat-option>
        <mat-option *ngFor="let city of city" [value]="city._id">
          {{ city.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('city')?.hasError('required')">
        Please select a city.
      </mat-error>
    </mat-form-field>
  </div>


  <div class="form_heading">
    <div class="heading-submenu second">
      Profile Questions</div>
  </div>


  <!-- -----------------------------profile fields-------------------- -->
  <!-- New Fields -->
  <div class="form-row">

    <mat-form-field appearance="outline" class="form-field">
      <label for="seekingFor">Seeking:</label>
      <mat-select id="ethnicity" formControlName="seekingFor">
        <mat-option value="" disabled="true">Select</mat-option>
        <mat-option *ngFor="let seeking of dropDownData?.seekingFor" [value]="seeking._id">{{ seeking.name
          }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('seekingFor')?.hasError('required')">
        Please select an seeking for.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <label for="religion">Religion:</label>
      <mat-select id="religion" formControlName="religion">
        <mat-option value="" disabled="true">Select</mat-option>
        <mat-option *ngFor="let religion of dropDownData?.religions" [value]="religion._id">
          {{ religion.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('religion')?.hasError('required')">
        Please select a religion.
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">

    <mat-form-field appearance="outline" class="form-field">
      <label for="ethnicity">Ethnicity:</label>
      <mat-select id="ethnicity" formControlName="ethnicity">
        <mat-option value="" disabled="true">select</mat-option>
        <mat-option *ngFor="let country of dropDownData?.ethnicities" [value]="country._id">
          {{ country.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('ethnicity')?.hasError('required')">
        Please select an ethnicity.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <label for="maritalStatus">Marital Status:</label>
      <mat-select id="maritalStatus" formControlName="maritalStatus">
        <mat-option value="" disabled="true">Select</mat-option>
        <mat-option *ngFor="let maritial of dropDownData?.maritalStatuses" [value]="maritial._id">
          {{ maritial.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('maritalStatus')?.hasError('required')">
        Please select your marital status.
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <label for="children">Childrens</label>
      <mat-select id="children" formControlName="children">
        <mat-option value="" disabled="true">Select</mat-option>
        <mat-option *ngFor="let child of dropDownData?.children" [value]="child._id">
          {{ child.name }}
        </mat-option>

      </mat-select>
      <mat-error *ngIf="formGroup.get('children')?.hasError('required')">
        Please select a clildren type.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <label for="bodyType">Body Type:</label>
      <mat-select id="bodyType" formControlName="bodyType">
        <mat-option value="" disabled="true">Select</mat-option>
        <mat-option *ngFor="let body of dropDownData?.bodyTypes" [value]="body._id">
          {{ body.name }}
        </mat-option>

      </mat-select>
      <mat-error *ngIf="formGroup.get('bodyType')?.hasError('required')">
        Please select a body type.
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <label for="smoker">Smoker:</label>
      <mat-select id="smoker" formControlName="smoker">
        <mat-option value="" disabled="true">Select</mat-option>
        <mat-option *ngFor="let smoker of dropDownData?.smokingHabits" [value]="smoker._id">
          {{ smoker.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('smoker')?.hasError('required')">
        Please select a smoker type.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <label for="drink">Drink:</label>
      <mat-select id="drink" formControlName="drink">
        <mat-option value="" disabled="true">Select</mat-option>
        <mat-option *ngFor="let smoker of dropDownData?.drinkingHabits" [value]="smoker._id">
          {{ smoker.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('drink')?.hasError('required')">
        Please select a body type.
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <label for="employment">Employment:</label>
      <mat-select id="employment" formControlName="employment">
        <mat-option value="" disabled="true">Select</mat-option>
        <mat-option *ngFor="let emp of dropDownData?.employment" [value]="emp._id">
          {{ emp.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('employment')?.hasError('required')">
        Please select a employment type.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <label for="education">Education:</label>
      <mat-select id="education" formControlName="education">
        <mat-option value="" disabled="true">Select</mat-option>
        <mat-option *ngFor="let edu of dropDownData?.education" [value]="edu._id">
          {{ edu.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('education')?.hasError('required')">
        Please select a education type.
      </mat-error>
    </mat-form-field>
  </div>


  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <label for="myMatch">My Match:</label>
      <input matInput id="myMatch" formControlName="myMatch" placeholder="Enter your match">
      <mat-error *ngIf="formGroup.get('myMatch')?.hasError('required')">
        Please select a myMatch.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <label for="pets">Pets:</label>
      <mat-select id="pets" formControlName="pets">
        <mat-option value="" disabled="true">Select</mat-option>
        <mat-option *ngFor="let pest of dropDownData?.pets" [value]="pest._id">
          {{ pest.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.get('pets')?.hasError('required')">
        Please select a pets type.
      </mat-error>
    </mat-form-field>
  </div>


  <div class="form-row textarea">
    <label for="about">About Me</label>
    <mat-form-field appearance="fill" class="form-field">
      <textarea matInput placeholder="Write about yourself" formControlName="about"></textarea>
      <mat-error *ngIf="formGroup.get('about')?.hasError('required')">
        Please fill this field.
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-row textarea">
    <label for="interst">My Interests</label>
    <mat-form-field appearance="fill" class="form-field">
      <textarea matInput placeholder="Write about your interests" formControlName="interest"></textarea>
    </mat-form-field>
  </div>
  <div class="form-row">
    <mat-checkbox formControlName="isPrivate" class="form-field">Make these profile questions private</mat-checkbox>
  </div>


  <div class="form-row">

    <div class="form-filed pro_img_flex">
      <div class="pro_img" (click)="triggerFileUpload(fileInput)">
        <img class="profile_img" [src]="imagePreview ? imagePreview : this.apiservices.frontendAssetsUrl+'default-profile-img.jpg'">
        <div class="update_profile_text_div" title="Update Profile Picture">
          <a id="change-profile-pic" class="">
            <fa-icon [icon]="faCamera"></fa-icon>
          </a>
        </div>
      </div>
      <div class="delete_profile" (click)="removeProfile()" *ngIf="imagePreview">
        <span>Remove Profile</span>
      </div>
    </div>

    <div class="form-filed">
      <input type="file" (change)="onFileSelected($event)" placeholder="Choose a file" #fileInput style="display:none"
        accept="image/*"/>

      
    </div>
  </div>



  <button mat-raised-button color="primary" type="submit">
    <span>{{showText? "Update": "Please Wait..."}}</span>
    <mat-spinner *ngIf="!showText" diameter="20"></mat-spinner>
  </button>
</form>

<p class="members-message">Did you complete all of the fields above? <br> Please Remember your profile will not appear
  on the members page until all fields are completed</p>